<template>
  <div class="sidebar-item mb-6">
    <Link :href="rallySelectionUrl" class="sidebar-item-title relative">
      {{ tenantName }}

      <CollapseButton :collapsed="true" class="ml-auto" />
    </Link>
  </div>

  <div
    v-if="hasItems"
    class="sidebar-menu space-y-6 pb-24"
    dusk="sidebar-menu"
    role="navigation"
  >
    <component
      :key="item.key"
      :is="item.component"
      v-for="(item, index) in mainMenu"
      :item="item"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MainMenu',

  computed: {
    ...mapGetters(['mainMenu']),

    hasItems() {
      return this.mainMenu.length > 0
    },

    tenantName() {
      return tenant.name
    },

    rallySelectionUrl() {
      return `/event-selection`
    },
  },
}
</script>
